import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_CHECKMARK } from '@bwoty-web/ui-kit/icons';
import './keySellingPointList.scss';

const KeySellingPointList = ({ ksps = [], className, limit = 3 }) => {
  if (ksps?.length < 1) {
    return null;
  }
  const maxNumberOfPoints = limit || undefined;

  return (
    <div className={className}>
      <ul className="gw-key-selling-point__list">
        {ksps?.slice(0, maxNumberOfPoints).map((usp) => {
          return (
            <li key={uniqid('gw-key-selling-point-list-item-')}>
              <Icon
                path={UI_CHECKMARK}
                size="xs"
                sizeMobile="xxxs"
                aria-hidden="true"
              />
              {usp}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

KeySellingPointList.propTypes = {
  ksps: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  limit: PropTypes.number,
};
KeySellingPointList.defaultProps = {
  className: '',
  ksps: [],
  limit: 3,
};

export default KeySellingPointList;
